export default __webpack_public_path__ + "images/36306e4281d492cb2cc319debe3c124f.png";